import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FAQS } from "@/data/faq";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { FAQAccordion } from "@/components/FAQAccordion";

export const FAQSection = () => (
  <section className="section bg-white" data-testid="faq-section">
    <div className="container-x grid gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-4">
        <SectionHead eyebrow="FAQ" title="Questions, answered." copy="The essentials about ANFORD, who it serves and what to expect." />
        <Reveal delay={0.1} className="mt-6">
          <Link to="/faq" data-testid="faq-view-all-link" className="inline-flex min-h-[44px] items-center gap-2 font-display text-sm font-bold text-navy transition-colors hover:text-gold">
            View all questions <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-8">
        <FAQAccordion items={FAQS.slice(0, 6)} testPrefix="home-faq" />
      </Reveal>
    </div>
  </section>
);
